<!--
# Frontend Vue | Vendor: FairVerify | App: Phoenix | Type: VisitorLeadDebugAuthModal
# FairVerify Event Solutions (fairverify.de) based on GodMode Core - GodMode.Systems
# Copyright Tim Haymann, FairVerify Event Solutions GmbH.
-->
<template>
  <div v-if="visible">
    <div class="modal d-block" tabindex="-1" role="dialog" @click.self="$emit('close')">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 rounded-4">
          <div class="modal-body px-4 pt-4 pb-3">
            <h2 class="h4 mb-3">{{ t('debug.unlockTitle') }}</h2>
            <p class="text-muted mb-3">{{ t('debug.unlockText') }}</p>
            <input
              v-model="passwordInput"
              type="password"
              class="form-control"
              :placeholder="t('debug.passwordPlaceholder')"
              @keyup.enter="handleSubmit"
            >
            <p v-if="authError" class="text-danger small mt-2 mb-0">{{ authError }}</p>
            <div class="mt-3 d-flex justify-content-end gap-2">
              <button class="btn btn-outline-secondary rounded-pill" type="button" @click="$emit('close')">
                {{ t('actions.cancel') }}
              </button>
              <button class="btn btn-primary rounded-pill" type="button" @click="handleSubmit">
                {{ t('actions.unlock') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import { translateVisitorLead } from '@/components/visitor-lead/i18n.js'

export default {
  name: 'VisitorLeadDebugAuthModal',
  props: {
    visible: { type: Boolean, default: false },
    authError: { type: String, default: '' },
    locale: { type: String, default: 'en' },
  },
  data() {
    return {
      passwordInput: '',
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.passwordInput = ''
      }
    },
  },
  methods: {
    t(key, replacements = {}) {
      return translateVisitorLead(key, replacements, this.locale)
    },
    handleSubmit() {
      this.$emit('submit', this.passwordInput)
    },
  },
}
</script>
